<template>
  <div>
    <HeaderUsers
      :arrow="false"
      title="Perfis de usuários"
      text="Gerencie os usuários cadastrados e cadastre novos usuários que terão acesso ao sistema"
      :haveAction="true"
      actionTitle="Novo Usuário"
      @action="addUser((item = {}))"
    />
    <v-container style="max-width: unset" class="pa-6 pt-2">
      <!-- Linha visivel filter -->
      <v-card
        transition="scale-transition"
        v-if="showFilters"
        class="d-column mt-0 mb-6 pt-2 pb-0"
        elevation="4"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <!-- Primeira linha de filtro -->
        <!-- <v-toolbar flat class="toolbar">
          <v-icon>mdi-chess-king</v-icon>
          <span>Masters</span>
          <span class="ma-3 px-3" style="color:black;max-width=350px">
            {{ countMaster }}
          </span>
          <v-icon>mdi-home-city</v-icon>
          <span>Admins</span>
          <span class="ma-3 px-3" style="color:black;max-width=350px">
            {{ countAdmin }}
          </span>
        </v-toolbar> -->
        <v-row class="pt-3 pr-6 pl-6 pb-2">
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="3"
            sm="3"
          >
            <v-text-field
              v-model="filter.Name"
              class="filterAutocomplete"
              item-text="Name"
              label="Usuário"
              prepend-inner-icon="mdi-magnify"
              attach
              dense
              outlined
              hide-no-data
              hide-details
              cache-items
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="3"
            sm="3"
          >
            <v-text-field
              class="filterAutocomplete"
              v-model="filter.Email"
              attach
              color="secondary"
              dense
              outlined
              hide-details
              style="width: 100%"
              item-text="email"
              item-value="UsersEmail"
              required
              label="E-mail"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-0 py-2"
            cols="12"
            md="3"
            sm="6"
          >
            <v-autocomplete
              class="filterAutocomplete"
              style="width: 100%"
              attach
              color="secondary"
              dense
              outlined
              @change="(page = 1), filterTable()"
              v-model="filter.Type"
              :items="tipos"
              item-text="label"
              item-value="value"
              label="Tipo"
              :rules="[(v) => !!v || 'Tipo requerido']"
              hide-details
              :loading="loading"
              required
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-row align-start my-1 py-1"
            cols="12"
            lg="3"
            md="3"
            sm="3"
          >
            <v-btn
              width="100%"
              class="mr-2"
              color="normaldark"
              elevation="2"
              style="
                border: 1px solid #bc0000;
                box-sizing: border-box;
                border-radius: 10px;
              "
              @click="reset"
              :loading="loading"
            >
              <v-icon class="pl-0">mdi-cached</v-icon>
              <span>Limpar</span>
            </v-btn>

            <!-- Export Excel -->
            <!-- <v-btn
              elevation="0"
              fab
              tile
              style="border-radius: 6px"
              small
              color="normaldark"
              @click="exportExcel"
            >
              <v-icon color="white">mdi-file-excel</v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
      </v-card>

      <!-- NewUser Dialog -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="newUserDialog"
        max-width="850px"
      >
        <NewUser
          title="Novo Usuário"
          :user="this.currentUser"
          @action="newUserDialog = false"
          @close="(newUserDialog = false), updateTable()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- Importar Excel -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="importDialog"
        max-width="650px"
      >
        <ImportExcel
          title="Importar Revendas"
          textMessage="Importar arquivos '.xlsx' (Excel) para agilizar o processo de adição de revendas em massa!"
          icone="mdi-arrow-down-circle"
          tipo="Revenda"
          route="Users"
          typeRoute="revendas"
          @close="(importDialog = false), updateTable()"
          @generate="(importDialog = false), updateTable()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- Exportar Excel -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="excelDialog"
        max-width="500px"
      >
        <ExcelModal
          title="Exportar Revendas"
          textMessage="Deseja exportar os usuários para excel ?"
          cancelBtn="Cancelar"
          okbtn="Sim, exportar"
          icone="mdi-arrow-up-circle"
          textObservation=""
          @close="excelDialog = false"
          @generate="(excelDialog = false), generateExcel()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- Dialog DELETE  -->
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="deleteDialog"
        max-width="450px"
      >
        <DeleteModal
          title="Deletar"
          textMessage="Tem certeza que deseja deletar este usuário?"
          cancelBtn="Cancelar"
          okbtn="Deletar"
          textObservation=""
          icone="mdi-restore-alert"
          @close="(deleteDialog = false), updateTable()"
          @action="(deleteDialog = false), remove()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <!-- ChangeStatus Dialog  -->
      <v-dialog v-model="changeDialog" max-width="450px">
        <AprovalModal
          :title="
            this.currentUser.status == 1 ? 'Ativar Usuário' : 'Inativar Usuário'
          "
          :textMessage="'Você confirma que deseja concluir esta ação?'"
          cancelBtn="Cancelar"
          :okbtn="this.currentUser.status == 1 ? 'ATIVAR' : 'INATIVAR'"
          textObservation=""
          icone="mdi-restore-alert"
          @close="(changeDialog = false), updateTable()"
          @action="(changeDialog = false), changeStatus()"
          @closeNoLoading="closeNoLoading"
          :key="dialogKey"
        />
      </v-dialog>

      <v-dialog v-model="confirmActionDialog" max-width="500">
        <ConfirmModal
            v-if="action"
            title=""
            textMessage=""
            :textObservation1="`Deseja realmente ${actions.find((x) => x.value === action).label} os usuários selecionados?`"
            textObservation2=""
            cancelBtn="Cancelar"
            okbtn="Sim"
            textObservation=""
            @close="(confirmActionDialog = false)"
            @action="performAction()"
        />
      </v-dialog>

      <v-dialog v-model="reasonsNoToDeleteUsersDialog" max-width="700">
        <v-card class="d-flex flex-column ma-0 pa-0">
          <h2 class="text-center mt-4">Usuários que não podem serem excluídos</h2>
          <ul class="mx-2 list_style" >
            <li v-for="(item, i) in listReasonsNoToDeleteUsers" :key="item.user.id" class="mt-5">
              <hr v-if="i > 0"/>
              <p class="mb-1">Usuário: <strong>{{ item.user.name }}</strong></p>
              <ul class="list_style">
                <li v-for="motive in item.motives" :key="motive">
                  <p class="mb-2"> {{motive}}</p>
                </li>
              </ul>
            </li>
          </ul>

          <section class="d-flex justify-center">
            <v-btn
                class="secondary-button my-3"
                style="height: 40px!important; border-radius: 7.5px!important"
                height="40"
                width="60%"
                elevation="0"
                :disabled="!action"
                @click="reasonsNoToDeleteUsersDialog = false"
            >
              Fechar
            </v-btn>
          </section>
        </v-card>
      </v-dialog>
      <!-- Tabela -->
      <v-data-table
        v-model="selectedUsers"
        ref="table"
        :loading="loading"
        loading-text="Carregando..."
        no-data-text="Nenhum usuário encontrado"
        :headers="headers"
        :items="users"
        class="elevation-5 mytable content-table"
        hide-default-footer
        :items-per-page="pageSize"
        :header-props="headerProps"
        item-key="id"
        :single-select="false"
        show-select
      >
        <template v-slot:[`header.download`]="{ header }">
          <v-btn
            outlined
            tile
            icon
            v-on="header"
            class="quinary-button"
            style="border-radius: 5px"
            @click="exportExcel"
          >
            <v-icon>mdi-download-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:[`item.type`]="{ item }">
          {{ userType[item.type] || "-" }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-select
            class="pa-2"
            style="max-width: 150px; font-weight: bold"
            dense
            hide-details
            outlined
            :items="status"
            @change="toggleChangeDialog(item)"
            item-text="label"
            item-value="value"
            v-model="item.status"
          >
          </v-select>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <section class="d-flex">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 4px; width: 35px; height: 35px"
                    small
                    class="table-button ma-1 edit-button"
                    color="quaternary"
                    @click="editUsers(item)"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon dark>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 4px; width: 35px; height: 35px"
                    small
                    class="table-button ma-1 edit-button"
                    color="red"
                    @click="deleteUsers(item)"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon dark>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </section>
        </template>

        <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
          <v-simple-checkbox
            :ripple="false"
            @click="addUserListSelectedUsers(item)"
            :value="isSelected"
            color="#bc0000"
            v-bind="props"
            v-on="on"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:header.data-table-select="{ on, props}">
          <v-simple-checkbox
            color="#bc0000"
            v-bind="props"
            v-on="on"
            :ripple="false"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:footer >
         <v-row cols="12" class="mx-5 mb-0 mt-1" v-if="selectedUsers.length > 0">
           <v-col cols="12" xs="12" sm="12" md="5" lg="4" xl="4" class="ma-0 pa-0 pa-2">
             <label>Selecione a ação</label>
             <v-select
                 class=""
                 dense
                 v-model="action"
                 outlined
                 style="border-radius: 3px!important"
                 :items="actions"
                 item-text="label"
                 item-value="value"
                 placeholder="Selecione a ação"
             >
             </v-select>
           </v-col>

           <v-col cols="12" xs="12" sm="12" md="4" lg="3" xl="3" class="ma-0 pa-2">
             <v-btn
                 class="secondary-button mt-5"
                 style="height: 40px!important; border-radius: 7.5px!important"
                 height="40"
                 width="100%"
                 elevation="0"
                 :disabled="!action"
                 @click="confirmActionDialog = true"
             >
               {{ action ? actions.find((x) => x.value === action).label : 'Selecione a ação'}}
             </v-btn>
           </v-col>
         </v-row>
        </template>

        <template v-slot:footer class="ma-0 pa-0">
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<style scoped>
.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box !important;
  border-radius: 8px !important;
  width: 100% !important;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
}

.table-button:hover {
  background: #2d3038 !important ;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}
/*.mytable {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);
}*/
.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 1024px) {
  .mytable {
    max-width: 100%;
  }
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table
    tbody
    tr:not(:last-child)
    td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
.list_style{
  list-style-type: decimal;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import ExcelModal from "../components/ExcelModal.vue";
import ImportExcel from "../components/ImportExcel.vue";
import HeaderUsers from "./components/HeaderUsers.vue";
import AprovalModal from "../components/AprovalModal.vue";
import DeleteModal from "../components/DeleteModal.vue";
import NewUser from "./components/newUser.vue";
import Pagination from "../components/Pagination.vue";
import router from "../../../router";
import Vue from "vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";

export default {
  data: () => ({
    tipos: [
      { label: "Master", value: 0 },
      { label: "Administrador", value: 1 },
      { label: "Financeiro", value: 5 },
      { label: "Marketing", value: 6 },
      { label: "Gerencial", value: 7 },
      { label: "Imprimextec", value: 8 },
    ],
    selectedUsers: [],
    listReasonsNoToDeleteUsers: [],
    reasonsNoToDeleteUsersDialog: false,
    newUserDialog: false,
    countMaster: "",
    countAdmin: "",
    disableStatus: false,
    ativos: [],
    length: "",
    UserssId: "",
    showFilters: true,
    rating: "",
    dialog: false,
    closeNoLoading: false,
    addDialog: false,
    confirmActionDialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    importDialog: false,
    changeDialog: false,
    excelDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    users: [],
    currentUser: {},
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 10,
    btnColor: "",
    sizes: [10, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      Name: null,
      Id: null,
      Type: null,
      Status: null,
      updated_at: null,
    },
    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    actions: [
      { label: "Inativar usuário(s)", value: 1},
      { label: "Ativar usuário(s)", value: 2},
      { label: "Excluir usuário(s)", value: 3},
    ],
    action: null,
    error: false,
    show: false,
    message: "",
    headers: [
      {
        text: "Usuário",
        align: "start",
        class: "item",
        value: "name",
        sortable: false,
      },
      {
        text: "Tipo",
        class: "item",
        value: "type",
        align: "start",
        sortable: false,
      },
      {
        text: "Email",
        class: "item",
        value: "email",
        align: "start",
        sortable: false,
      },
      {
        text: "Data Cadastro",
        class: "item",
        value: "created_at",
        align: "start",
        sortable: false,
      },
      {
        text: "Status",
        class: "item",
        value: "status",
        align: "center",
        sortable: false,
      },

      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
      {
        align: "center",
        sortable: false,
        value: "download",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    userType: {
      0: "Master",
      1: "Admin",
      2: "Revenda",
      3: "Aplicador",
      4: "Cliente",
      5: "Financeiro",
      6: "Marketing",
      7: "Gerencial",
      8: "Imprimaxtec"
    }
  }),

  components: {
    ConfirmModal,
    HeaderUsers,
    ImportExcel,
    ExcelModal,
    AprovalModal,
    DeleteModal,
    NewUser,
    Pagination,
  },

  computed: {},

  async created() {
    const jsonFilters = JSON.parse(localStorage.getItem("ordersUsersFilters"));

    if (jsonFilters){
      this.filter = jsonFilters
      this.page = this.filter.page;
    }

    await this.updatePageView();
  },

  methods: {
    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.action).label) {
        case 'Inativar usuário(s)':
          this.inactivateUser()
              break
        case 'Ativar usuário(s)':
          this.activateUsers()
              break
        default:
          this.removeUsers()
      }
    },
    async inactivateUser() {
      try {
        const selectedUsers = JSON.parse(JSON.stringify(this.selectedUsers))
        selectedUsers.forEach((x) => {
          x.status = 0;
        })
        await this.apiService
            .put(`user/update_status`, selectedUsers)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "tatus dos usuários atualizados com sucesso!",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {

      }
    },
    async activateUsers() {
      try {
        const selectedUsers = JSON.parse(JSON.stringify(this.selectedUsers))
        selectedUsers.forEach((x) => {
          x.status = 1;
        })
        await this.apiService
            .put(`user/update_status`, selectedUsers)
            .then(async (response) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Status dos usuários atualizados com sucesso!",
                trace: null,
              });
              await this.updateTable()
            });
      } catch (e) {

      }
    },
    async removeUsers() {
      try {
        const {statusCode, content} = await this.reasonsNoToDeleteUsers()
        if (content && content.length > 0) {
          this.listReasonsNoToDeleteUsers = content;
          this.reasonsNoToDeleteUsersDialog = true;
          return
        }
        await this.apiService
          .post(`user/delete_users`, this.selectedUsers)
          .then(async (response) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "",
              message: "Usuários excluídos com sucesso!",
              trace: null,
            });
            await this.updateTable()
          });

      } catch (e) {

      }
    },
    async reasonsNoToDeleteUsers() {
      try {
        return await this.apiService.post(`user/reasons_not_to_delete_users`, this.selectedUsers)
      } catch (e) {

      }
    },


    addUserListSelectedUsers(user){
      const userFind = this.selectedUsers.findIndex((x) => x.id === user.id)
      if(userFind > -1){
        this.selectedUsers.splice(userFind, 1)
      } else {
        this.selectedUsers.push(user)
      }
    },

    async updatePageView() {
      this.filter.Status = null;
      await this.updateTable();
      // this.countAdmin = this.resales.filter((resale) => resale.status == 1).length;
      // this.countMaster = this.resales.filter((resale) => resale.status == 0).length;
    },

    addUser() {
      localStorage.setItem("ordersUsersFilters", JSON.stringify(this.filter));
      this.currentUser = {};
      this.dialogKey = !this.dialogKey;
      this.newUserDialog = true;
    },

    formatDate(date) {
      return Utils.momentDay(date);
    },

    parse_date(date) {
      var momentDate = moment(date);
      return (
        momentDate.format("DD") /
        momentDate.format("MM") /
        momentDate.format("YYYY")
      );
    },

    toggleChangeDialog(item) {
      this.approveSelectedItem = item;
      this.currentUser = item;
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
    },

    editUsers(item) {
      localStorage.setItem("ordersUsersFilters", JSON.stringify(this.filter));
      this.currentUser = item;
      this.dialogKey = !this.dialogKey;
      this.newUserDialog = true;
    },

    deleteUsers(user) {
      localStorage.setItem("ordersUsersFilters", JSON.stringify(this.filter));
      this.currentUser = user;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    exportExcel(users) {
      this.currentUser = users;
      this.dialogKey = !this.dialogKey;
      this.excelDialog = true;
    },

    detailsUsers(user) {
      this.currentUser = user;
      this.dialogKey = !this.dialogKey;
      this.detailsDialog = true;
    },

    importExcel(user) {
      this.dialogKey = !this.dialogKey;
      this.importDialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.editDialog = false;
      this.deleteDialog = false;
      this.importDialog = false;
      this.detailsDialog = false;
      this.dialogKey = !this.dialogKey;
      this.updateTable();
    },

    openAbout(user) {
      this.currentUser = user;
      this.$router.push("/details-users");
    },

    filterTable() {
      this.loading = true;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      if (this.filter.Status == "Inativo") {
        this.filter.Status = 0;
      } else if (this.filter.Status == "Ativo") {
        this.filter.Status = 1;
      } else {
        this.filter.Status = null;
      }

      if (this.UsersInicialDate > this.UsersFinalDate) {
        this.error = true;
        this.reset();
        setTimeout(() => {
          this.error = false;
        }, 4000);
        return;
      }

      this.updateTable();
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;

      await this.apiService.post(`user/list`, this.filter).then((response) => {
        this.users = response.users;
        this.totalPages = response.pager.totalPages;
        this.totalItems = response.pager.totalItems;
        this.currentPage = response.pager.currentPage;
        this.loading = false;
        this.isLoading = false;
        this.action = null;
      });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    reset() {
      (this.filter = ""),
        (this.filter = {
          page: 1,
          pageSize: 10,
        });
      this.page = 1;
      localStorage.setItem("ordersUsersFilters", null);
      this.updateTable();
    },

    close() {
      this.$emit("close");
    },

    async remove() {
      this.loading = true;
      await this.apiService
        .delete(`user/delete`, this.currentUser)
        .then(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Usuário removido com sucesso!",
            message: "",
            trace: null,
          });
          this.updateTable();
          this.close();
          this.deleteDialog = false;
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possivel remover este usuário!",
            message: err.body.message,
            trace: null,
          });
          this.$router.push("/users");

          this.close();
          this.deleteDialog = false;
          this.loading = false;
        });
    },

    changeStatus(item) {
      item = this.approveSelectedItem;
      if (item.status == 0) {
        item.status = 1;
      } else if (item.status == 1) {
        item.status = 0;
      }

      this.editStatus(item);
    },

    async editStatus(item) {
      this.loading = true;
      this.currentUser = item;

      await this.apiService
        .post(`user/changestatus`, this.currentUser)
        .then((resp) => {
          this.updatePageView();
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Mudança de status efetuada!",
            message: "",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível mudar o status do aplicador",
            message: erro.body.message,
            trace: null,
          });
        });
    },

    async generateExcel() {
      this.loading = true;

      let now = new Date();
      var filename =
        `Usuários_` +
        `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
        .post("user/excel", this.filter)
        .then((response) => {
          response = "data:application/octet-stream;base64," + response;
          const link = document.createElement("a");
          link.href = response;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
          // this.$emit("close");
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Não foi possível efetuar a exportação",
            message: erro.body.message,
            trace: null,
          });
        });
    },
  },

  watch: {

  },
};
</script>
